import PropTypes from 'prop-types';
import React from 'react';
import { connect, useSelector } from 'react-redux';
import FunctionalityAccessHelper from '../../helpers/functionality_access_helper';

import Actions from '../../actions/actions';
import AuthHelper from '../../helpers/auth_helper';
import NavbarContent from './navbar_content';
import Constants from '../../helpers/constants';
import Anchor from '../shared/anchor';

const HeaderBar = ({ hamburgerMenu }) => {
  const user = useSelector((redux) => redux.user);
  const view = useSelector((redux) => redux.view);
  const userFunctionalityAcls = useSelector((redux) => redux.userFunctionalityAcls);
  const adminFinancingRequest = useSelector((redux) => redux.adminFinancingRequest);
  const hideHeader = useSelector((redux) => redux.hideHeader);
  const { page, tier } = view;

  const clearCustomerData = () => {
    Actions.clearCustomer();
    Actions.clearFinancingMethod();
    Actions.clearProposal();
    Actions.clearEligibility();
  };

  const baseNavigate = async () => {
    const impersonatedUser = AuthHelper.getImpersonateCookie();
    switch (page) {
      case 'admin':
      case 'frDocumentsTier1List':
      case 'frDocumentsTier2List':
      case 'frDocumentsEscalatedList':
        Actions.setRoute('/admin');
        clearCustomerData();
        break;
      case 'frDocumentsDetails':
        let promise;
        if (adminFinancingRequest !== null) {
          const { id: adminFinancingRequestId, lockedForEditingByUserId } = adminFinancingRequest;
          if (lockedForEditingByUserId !== null && user !== null && user.id === lockedForEditingByUserId) {
            promise = Actions.unlockAdminFinancingRequest(adminFinancingRequestId);
          }
        }
        if (promise) {
          promise.then(() => navigateToTierPage(tier));
        } else {
          navigateToTierPage(tier);
        }
        break;
      case 'newProposal':
        if (user !== null && user.atype === 'CPF' && !impersonatedUser) {
          Actions.setRoute('/admin');
        } else {
          Actions.setRoute('/customers');
        }
        clearCustomerData();
        break;
      default:
        Actions.setRoute('/customers');
        clearCustomerData();
    }
  };

  const navigateToTierPage = (tierPage) => {
    switch (tierPage) {
      case 'tier_1':
        Actions.setRoute('/admin/financing-request-documents/tier-1');
        break;
      case 'tier_2':
        Actions.setRoute('/admin/financing-request-documents/tier-2');
        break;
      case 'escalated':
        Actions.setRoute('/admin/financing-request-documents/escalated');
        break;
      default:
        Actions.setRoute('/admin');
        break;
    }
  };

  const baseLinkLabel = () => {
    let label;
    const impersonatedUser = AuthHelper.getImpersonateCookie();
    switch (page) {
      case 'admin':
      case 'frDocumentsTier1List':
      case 'frDocumentsTier2List':
      case 'frDocumentsEscalatedList':
        label = 'Admin Dashboard';
        break;
      case 'frDocumentsDetails':
        label = 'Back to List';
        break;
      case 'newProposal':
        if (user !== null && user.atype === 'CPF' && !impersonatedUser) {
          label = 'Admin Dashboard';
        } else {
          label = 'Customer List';
        }
        break;
      default:
        label = 'Customer List';
    }

    return label;
  };

  const navigateDisbursement = async () => {
    Actions.setRoute('/disbursements');
    clearCustomerData();
  };

  const navigateProductCompare = async () => {
    Actions.setRoute('/proposal/new');
    Actions.setView({ page: 'newProposal', tab: 'product-comparison' });
    clearCustomerData();
  };

  const getMenuItems = (userComplied, cashOnly) => {
    let hasAccessToCustomerList = false;
    let hasAccessToDisbusements = false;
    let hasProductComparison = false;

    if (userFunctionalityAcls !== undefined && userFunctionalityAcls !== null) {
      hasAccessToCustomerList = FunctionalityAccessHelper.hasAccessToAdvancedCustomersList(userFunctionalityAcls);
      hasAccessToDisbusements = FunctionalityAccessHelper.hasAccessToDisbursements(userFunctionalityAcls);
      hasProductComparison = FunctionalityAccessHelper.hasACL(
        userFunctionalityAcls,
        Constants.FUNCTIONALITY_ACL_PRODUCT_COMPARISON
      );
    }

    let items = [];
    let i = 0;
    if (userComplied) {
      if (hasAccessToCustomerList) {
        items.push(
          <Anchor key={i++} className="header-text" onClick={baseNavigate} id="customer-list-link">
            {baseLinkLabel()}
          </Anchor>
        );
      }
      if (hasAccessToDisbusements) {
        items.push(
          <Anchor key={i++} className="header-text" onClick={navigateDisbursement} id="disbursement-list-link">
            Disbursements
          </Anchor>
        );
      }
      if (hasProductComparison && !cashOnly) {
        items.push(
          <Anchor key={i++} className="header-text" onClick={navigateProductCompare} id="product-comparison-list-link">
            Product Comparison
          </Anchor>
        );
      }
    }

    return items;
  };

  const userComplied = user?.userAgreementComp !== 0;
  const cashOnly = user?.products?.every((p) => p?.productSku?.startsWith('CASH_'));

  if (hideHeader) {
    return <div className="header-links" />;
  }

  if (!user || (Array.isArray(user) && user.length === 1 && JSON.stringify(user) === '[{}]')) {
    return <div className="header-links" />;
  }

  return (
    <div className="header-links">
      <NavbarContent {...{ user, userComplied, hamburgerMenu }} menuItems={getMenuItems(userComplied, cashOnly)} />
    </div>
  );
};

HeaderBar.propTypes = {
  hamburgerMenu: PropTypes.bool,
};

// I know it looks unused but it's crucial that the header bar rerender on changed view or else react-router may throw 404s
// Once we migrate fully to react-router, swap to the proper export and ensure that the below test passes
//  Scenario: After MFA verification, logout and log back in prompts MFA verification
export default connect(({ view }) => ({ view }))(HeaderBar);
// export default HeaderBar;
